import ProductMedia from './ProductMedia'

const getFallbackCopy = (product) =>
  product.presentation || product.description || 'Descubre este producto en video y revisa sus detalles.'

const getProductActivity = (product) => {
  const count = Number(product.videoCount || 0)
  if (count <= 0) return 'Nuevo en el catalogo'
  if (count === 1) return '1 video disponible'
  return `${count} videos disponibles`
}

const formatPrice = (value) => new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0
}).format(Number(value || 0))

export default function PublicCatalogProductItem({ product, onAddToCart, onOpenDetails }) {
  return (
    <button
      type="button"
      onClick={() => onOpenDetails(product)}
      className="grid grid-rows-[220px_auto] w-full max-w-full min-h-[440px] bg-white border border-[#d5d9d9] rounded-lg overflow-hidden shadow-sm hover:-translate-y-0.5 hover:shadow-md hover:border-amber-400 transition-all duration-200"
    >
      <div className="relative overflow-hidden bg-white border-b border-[#eaeded] h-full">
        <ProductMedia product={product} />
      </div>

      <div className="flex flex-col gap-1.5 p-3 bg-white">
        <div className="text-[11px] text-[#565959] leading-tight">Patrocinado</div>
        {product.categoryName && (
          <div className="inline-flex items-center w-fit max-w-full rounded-full px-2 py-0.5 bg-blue-50 text-blue-600 text-[9px] font-bold truncate">
            {product.categoryName}
          </div>
        )}
        <div className="text-[15px] leading-[1.3] font-medium text-[#0f1111] line-clamp-4 min-h-[30px]">
          {product.name}
        </div>
        <div className="flex items-center gap-1.5 flex-wrap text-xs text-[#0f1111]">
          <span>4.7</span>
          <span className="text-orange-500 tracking-[0.04em]">★★★★★</span>
          <span className="text-[11px] text-sky-700">({product.videoCount || 0})</span>
        </div>
        <div className="text-[11px] leading-[1.35] text-[#565959] line-clamp-2">
          {getFallbackCopy(product)}
        </div>
        <div className="flex items-end gap-1 text-[#0f1111] leading-none">
          <span className="text-[28px] tracking-[-0.03em]">{formatPrice(product.price)}</span>
        </div>
        <div className="grid gap-2 mt-1.5">
          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 min-h-8 px-3 rounded-full bg-[#ffa41c] text-[#0f1111] text-[11px] font-bold border border-[#ff8f00]"
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onAddToCart(product, 1)
            }}
          >
            <span className="text-base leading-none">+</span>
            <span>Agregar al carrito</span>
          </button>
        </div>
      </div>
    </button>
  )
}
